import { useOnline } from "../../lib/useOnline";

/**
 * A club basement loses signal. Without this the panel just stops updating
 * and every save fails one by one; with it the manager knows why before
 * touching anything.
 */
export function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div
      role="status"
      className="rp-enter-toast pointer-events-none fixed inset-x-0 top-3 z-[65] flex justify-center px-4 max-[899px]:top-[calc(10px+env(safe-area-inset-top))]"
    >
      <p className="flex items-center gap-2 rounded-full border border-warn/40 bg-panel-3 px-4 py-2 text-[13px] font-medium shadow-float">
        <span aria-hidden="true" className="h-2 w-2 rounded-full bg-warn" />
        Brak internetu. Dane mogą być nieaktualne, zmiany nie zostaną zapisane.
      </p>
    </div>
  );
}
